import Vue from "vue";
import Requests from "@/constants/Requests";

const ApplicationService = {
  fetchList: (page, orderBy, filters, date) => {
    let params = new URLSearchParams();
    params.append("page", page);

    params.append("order-by", orderBy);
    params.append("filters", filters);
    params.append("date", date);

    return Vue.prototype.$http.get(Requests.applications.list, {
      params: params
    });
  },
  apply: params => {
    let formData = new FormData();
    for (const key in params) {
      if (key === "documents") {
        for (let i = 0; i < params[key].length; i++) {
          formData.append("documents[]", params[key][i]);
        }
      } else {
        formData.append(key, params[key]);
      }
    }

    return Vue.prototype.$http.post(Requests.applications.apply, formData);
  },
  reject: offerId => {
    return Vue.prototype.$http.delete(
      `${Requests.applications.delete}/${offerId}`
    );
  },
  revoke: id => {
    return Vue.prototype.$http.post(
      Requests.applications.revoke.replace("{id}", id)
    );
  },
  showFamily: id => {
    return Vue.prototype.$http.post(
      Requests.applications.showFamily.replace("{pkKundeExcId}", id)
    );
  },

};

export default ApplicationService;
